<template>
  <div class="container">
    <div style="padding-bottom: 8px">
      <a-input
        v-model="lngLat"
        style="width: 200px;margin: 0 16px"
        placeholder="请输入经纬度"
      /><a-button type="primary" @click="confirm">确定</a-button
      ><span style="margin-left: 16px;color: gray"
        >在地图上选择经纬度或输入经纬度(以逗号隔开)</span
      >
    </div>
    <div id="map" class="map"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import debounce from "lodash/debounce";
export default {
  data() {
    return {
      map: null,
      lngLat: ""
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    curLngLat: {
      type: String,
      default: ""
    },
    trackDataInfo: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState(["mapTheme", "projectInfo"])
  },
  watch: {
    curLngLat(v) {
      if (v.split(",").length != 2) {
        return;
      }
      this.lngLat = v;
    },
    lngLat: debounce(function() {
      if (this.lngLat.split(",").length != 2) {
        return;
      }
      if (!this.map) {
        return;
      }
      let zoom = this.map.getZoom();
      this.map.setZoomAndCenter(
        zoom,
        new AMap.LngLat(this.lngLat.split(",")[0], this.lngLat.split(",")[1])
      );
      this.marker && this.map.remove(this.marker);
      this.marker = new AMap.Marker({
        map: this.map,
        position: [this.lngLat.split(",")[0], this.lngLat.split(",")[1]]
      });
    }, 500)
  },
  mounted() {
    this.lngLat = this.curLngLat;
    this.initMap();
  },
  methods: {
    initMap() {
      var map = new AMap.Map("map", {
        zoom: 11
      });

      this.map = map;
      this.map.setCity(this.projectInfo.city || "济南");
      this.map.setMapStyle(this.mapTheme);
      this.map.on("click", e => {
        this.marker && this.map.remove(this.marker);
        this.marker = new AMap.Marker({
          map: this.map,
          position: [e.lnglat.getLng(), e.lnglat.getLat()]
        });
        this.lngLat = e.lnglat.getLng() + "," + e.lnglat.getLat();
      });

      if (this.lngLat) {
        return;
      }
      if (!this.trackDataInfo?.data?.length) {
        return;
      }
      // 根据轨迹经纬度，自动缩放地图到合适的视野级别
      setTimeout(() => {
        const { columns, data } = this.trackDataInfo;
        const lngIndex = columns.indexOf("lng");
        const latIndex = columns.indexOf("lat");
        const path = [];
        data.forEach(x => {
          path.push(coordtransform.wgs84togcj02(x[lngIndex], x[latIndex]));
        });
        const polyline = new AMap.Polyline({
          path: path
        });
        // this.map.add(polyline);
        this.map.setFitView(polyline);
      }, 200);
    },
    confirm() {
      if (this.lngLat.split(",").length != 2) {
        this.$message.warning("经纬度以逗号隔开");
        return;
      }
      this.$emit("getLngLat", this.lngLat);
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
}
.map {
  width: 100%;
  height: 500px;
}
</style>
